import { Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from "@mui/material";
import axios from "axios";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { MdArrowBack } from "react-icons/md";
import { Commet } from "react-loading-indicators";
import { useNavigate } from "react-router-dom";
import { Button } from "rsuite";
import { web_url } from "../../constant";

function ApproveInvitations() {
    const [language, setLanguage] = useState(() => {
        const categoryNow = localStorage.getItem('language') ? localStorage.getItem('language') : 'English';
        return categoryNow;
    })
    const { t, i18n } = useTranslation();
    useEffect(() => {
        switch (language) {
            case 'English':
                i18n.changeLanguage('en');
                break;
            case 'Sinhala':
                i18n.changeLanguage('si');
                break;
            case 'Tamil':
                i18n.changeLanguage('ta');
                break;
            default:
                i18n.changeLanguage('en');
                break;
        }
        localStorage.setItem('language', language);
    }, [language]);
    const navigate = useNavigate();
    const [open, setOpen] = useState(false);

    const handleClickOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };

    const changeLanguage = (lang) => {
        i18n.changeLanguage(lang);
    };

    const [open2, setOpen2] = useState(false);
    const [isLoading, setIsLoading] = useState(false);

    const handleClickOpen2 = () => {
        setOpen2(true);
    };

    const handleClose2 = () => {
        setOpen2(false);
    };

    const [approveRequests, setApproveRequests] = useState([]);
    const [isLoadingPage, setIsLoadingPage] = useState(false);

    useEffect(() => {
        if (localStorage.getItem('assignedClass')) {
            setIsLoadingPage(true);

            const getLogDetails2 = () => {
                return JSON.parse(localStorage.getItem("logDetails")) || JSON.parse(sessionStorage.getItem("logDetails"));
            };
            const logDetails2 = getLogDetails2();

            const configToken = {
                headers: {
                    'Authorization': `Bearer ${logDetails2.token}`,
                },
            };

            axios.get(`${web_url}/api/auth/students`, configToken)
                .then((response) => {
                    console.log(localStorage.getItem('assignedClass'));

                    const pendingRequests = response.data
                        // .filter(record => (record.accountStatus === "PENDING") && (record.teacherName === 'Teacher test'))
                        .filter(record => (record.assignedClass === localStorage.getItem('assignedClass')) && (record.school === localStorage.getItem('school')) && (record.district === localStorage.getItem('district')) && (record.accountStatus === "PENDING") && (record.teacherName === (localStorage.getItem('name'))))
                        .map(record => ({
                            sEmail: record.userEmail,
                            sName: record.userFullName
                        }));
                    console.log(pendingRequests);

                    setApproveRequests(pendingRequests);
                    setIsLoadingPage(false);
                })
                .catch((err) => {
                    console.log("Error occurred", err);
                });
        }

    }, []);

    const [openError, setOpenError] = useState(false);
    const [error, setError] = useState('');

    const handleClickOpenError = (err) => {
        if (err.toLowerCase().includes('internal server error')) {
            setError(t('t93'));
        } else {
            setError(t('t94'));
        }
        setOpenError(true);
    };

    const handleCloseError = () => {
        setOpenError(false);
        navigate('/teacher/request/select')
    };

    const handleApproveReq = (email, index) => {
        setIsLoadingPage(true);
        const getLogDetails2 = () => {
            return JSON.parse(localStorage.getItem("logDetails")) || JSON.parse(sessionStorage.getItem("logDetails"));
        };
        const logDetails2 = getLogDetails2();

        const configToken = {
            headers: {
                'Authorization': `Bearer ${logDetails2.token}`,
            },
        };
        axios.put(`${web_url}/api/auth/students/${email}/account-status?status=ACTIVE`, {}, configToken)
            .then((response) => {
                setApproveRequests((prevRequests) =>
                    prevRequests.filter((_, i) => i !== index)
                );
                setIsLoadingPage(false);
            })
            .catch((err) => {
                if (err.response) {
                    console.log(err.response)
                    if (err.response.data.error) {
                        handleClickOpenError(err.response.data.error);
                    } else if (err.response.data.message) {
                        handleClickOpenError(err.response.data.message);
                    } if (err.response.data.token) {
                        handleClickOpenError(err.response.data.token);
                    } else {
                        handleClickOpenError("An unknown error occured");
                    }

                }
                else {
                    handleClickOpenError("An unknown error occured");
                }
                setIsLoadingPage(false);
            })
    }

    const handleDeleteAccountReq = (email, index) => {
        setIsLoadingPage(true);
        const getLogDetails2 = () => {
            return JSON.parse(localStorage.getItem("logDetails")) || JSON.parse(sessionStorage.getItem("logDetails"));
        };
        const logDetails2 = getLogDetails2();

        const configToken = {
            headers: {
                'Authorization': `Bearer ${logDetails2.token}`,
            },
        };
        axios.delete(`${web_url}/api/auth/students/${email}`, configToken)
            .then((response) => {
                setApproveRequests((prevRequests) =>
                    prevRequests.filter((_, i) => i !== index)
                );
                setIsLoadingPage(false);
            })
            .catch((err) => {
                if (err.response) {
                    console.log(err.response)
                    if (err.response.data.error) {
                        handleClickOpenError(err.response.data.error);
                    } else if (err.response.data.message) {
                        handleClickOpenError(err.response.data.message);
                    } if (err.response.data.token) {
                        handleClickOpenError(err.response.data.token);
                    } else {
                        handleClickOpenError("An unknown error occured");
                    }

                }
                else {
                    handleClickOpenError("An unknown error occured");
                }
                setIsLoading(false);
            })
    }

    return (
        <>
            <div className={`${i18n.language === "en" ? "font-urban" : (i18n.language === "si" ? "font-noto" : "font-mukta")} min-h-screen w-screen xl:pt-[20px]`}>

                <div className="pt-[100px] md:pt-[130px] lg:pt-[150px] xl:pt-[0px] w-full">
                    <div className="ml-[30px] md:ml-[60px] lg:ml-[80px] xl:ml-[80px] w-full flex justify-start flex items-center">
                        <MdArrowBack size={25} className="md:hidden" onClick={() => {
                            navigate('/teacher/request/select')
                        }} />
                        <MdArrowBack size={30} className="hidden md:block xl:hidden" onClick={() => {
                            navigate('/teacher/request/select')
                        }} />
                        <MdArrowBack size={30} className="hidden xl:block" onClick={() => {
                            navigate('/teacher/request/select')
                        }} />
                        <p className="text-[20px] md:text-[23px] lg:text-[25px] xl:text-[20px] 2xl:text-[22px] font-bold px-[10px] py-[5px] md:px-[13px] md:py-[8px]">{t('t112')}</p>
                    </div>
                </div>

                {
                    isLoadingPage ? <div className="items-center justify-center flex pt-[30px]">
                        <div className='w-10 h-10 border-2 border-t-transparent border-[#FFA803] rounded-full animate-spin'></div>
                    </div>
                        :
                        <>
                            {
                                approveRequests.length > 0 ? <>
                                    <div className="mt-[10px] md:mt-[20px] xl:hidden pb-[100px]">
                                        {
                                            approveRequests.map((request, index) => (
                                                <div className="mt-[10px] md:mt-[15px] flex items-center justify-between px-[20px] ml-[20px] mr-[10px] md:ml-[100px] md:mr-[100px] lg:ml-[140px] lg:mr-[140px] bg-[#F1F6FB] py-[10px] rounded-lg">
                                                    <div className="md:hidden flex flex-col">
                                                        <p className="text-[#8189B0] text-[12px] font-bold">{request.sName.length > 30
                                                            ? `${request.sName.slice(0, 30)}...`
                                                            : request.sName}</p>
                                                        <p className="text-[#8189B0] text-[12px] ">{request.sEmail.length > 30
                                                            ? `${request.sEmail.slice(0, 30)}...`
                                                            : request.sEmail}</p>
                                                    </div>
                                                    <div className="hidden md:flex flex-col">
                                                        <p className="text-[#8189B0] text-[15px] font-bold">{request.sName.length > 35
                                                            ? `${request.sName.slice(0, 35)}...`
                                                            : request.sName}</p>
                                                        <p className="text-[#8189B0] text-[15px] ">{request.sEmail.length > 35
                                                            ? `${request.sEmail.slice(0, 35)}...`
                                                            : request.sEmail}</p>
                                                    </div>
                                                    <div className="flex flex-col">
                                                        <button onClick={() => handleApproveReq(request.sEmail, index)} className="bg-[#BBFFA3] text-black text-[13px] rounded-lg py-[3px] w-[100px]">{t('t123')}</button>
                                                        <button onClick={() => handleDeleteAccountReq(request.sEmail, index)} className="mt-[5px] bg-[#FFBEA3] text-black text-[13px] rounded-lg py-[3px] w-[100px]">{t('t124')}</button>
                                                    </div>
                                                </div>
                                            )
                                            )
                                        }
                                    </div>

                                    <div className="mt-[10px] hidden xl:grid grid-cols-3 pb-[50px] ml-[80px] mr-[70px]">
                                        {
                                            approveRequests.map((request, index) => (
                                                <div key={index} className="mt-[10px] flex items-center justify-between px-[20px] ml-[10px] mr-[5px] bg-[#F1F6FB] py-[10px] rounded-lg">
                                                    <div className="2xl:hidden flex flex-col">
                                                        <p className="text-[#8189B0] text-[11px] 2xl:text-[13px] font-bold">{request.sName.length > 40
                                                            ? `${request.sName.slice(0, 40)}...`
                                                            : request.sName}</p>
                                                        <p className="text-[#8189B0] text-[11px] 2xl:text-[13px] ">{request.sEmail.length > 40
                                                            ? `${request.sEmail.slice(0, 40)}...`
                                                            : request.sEmail}</p>
                                                    </div>
                                                    <div className="hidden 2xl:flex flex-col">
                                                        <p className="text-[#8189B0] text-[11px] 2xl:text-[13px] font-bold">{request.sName.length > 45
                                                            ? `${request.sName.slice(0, 45)}...`
                                                            : request.sName}</p>
                                                        <p className="text-[#8189B0] text-[11px] 2xl:text-[13px] ">{request.sEmail.length > 45
                                                            ? `${request.sEmail.slice(0, 45)}...`
                                                            : request.sEmail}</p>
                                                    </div>
                                                    <div className="flex flex-col">
                                                        <button onClick={() => handleApproveReq(request.sEmail, index)} className="bg-[#BBFFA3] text-black text-[13px] rounded-lg py-[3px] w-[100px]">{t('t123')}</button>
                                                        <button onClick={() => handleDeleteAccountReq(request.sEmail, index)} className="mt-[5px] bg-[#FFBEA3] text-black text-[13px] rounded-lg py-[3px] w-[100px]">{t('t124')}</button>
                                                    </div>
                                                </div>

                                            ))
                                        }
                                    </div>
                                </> : <>
                                    <div className="flex  justify-center pt-[40px] font-bold text-black text-[15px] md:text-[17px] lg:text-[19px] xl:text-[17px]"><p>{t('t126')}</p></div>
                                </>
                            }
                        </>
                }
            </div>
            <Dialog
                open={open2}
                onClose={(event, reason) => {
                    if (reason !== "backdropClick") {
                        handleClose2(); // Allow closing only for other reasons
                    }
                }}
                aria-labelledby="custom-dialog-title"
                aria-describedby="custom-dialog-description"
                className="backdrop-blur-sm mr-[30px] md:mr-[0px]"
            >
                <DialogContent className="bg-[#FFF6DA]">
                    {!isLoading &&
                        <DialogContent
                            id="custom-dialog-description"
                            className="text-gray-600 text-md mt-2"
                        >
                            <div className='flex flex-col justify-center items-center text-center'>
                                <img src='/images/success.svg' alt='success' />
                                <div className='mt-[30px]'>Invitation sent succesfully</div>
                                <Button
                                    onClick={handleClose2}
                                    className="bg-[#F2AC0E] text-white px-4 py-2 rounded-md mt-[10px]"
                                    style={{ backgroundColor: '#F2AC0E', color: 'white', fontWeight: 'bold' }}
                                >
                                    Close
                                </Button>
                            </div>
                        </DialogContent>
                    }

                    {
                        isLoading &&
                        <DialogContentText
                            id="custom-dialog-description"
                            className="text-gray-600 text-md mt-2"
                        >
                            <Commet color="#FDC50C" size="medium" text="" textColor="" />
                        </DialogContentText>
                    }

                </DialogContent>
            </Dialog>

            <Dialog
                open={openError}
                onClose={(event, reason) => {
                    if (reason !== "backdropClick") {
                        handleCloseError(); // Allow closing only for other reasons
                    }
                }}
                aria-labelledby="custom-dialog-title"
                aria-describedby="custom-dialog-description"
                className="backdrop-blur-sm"
            >
                <DialogTitle
                    id="custom-dialog-title"
                    className="text-2xl font-bold text-gray-800 border-b border-gray-300 pb-2"
                >
                    {t('t95')}
                </DialogTitle>
                <DialogContent className="bg-gray-50">
                    <DialogContentText
                        id="custom-dialog-description"
                        className="text-gray-600 text-md mt-2"
                    >
                        {error}
                    </DialogContentText>
                </DialogContent>
                <DialogActions className="px-4 py-2">
                    <Button
                        onClick={handleCloseError}
                        className="bg-[#F2AC0E] text-white px-4 py-2 rounded-md"
                        style={{ backgroundColor: '#F2AC0E', color: 'white', fontWeight: 'bold' }}
                    >
                        {t('t96')}
                    </Button>
                </DialogActions>
            </Dialog>
        </>
    )
}

export default ApproveInvitations;
